import LoadingSpinner from "components/others/LoadingSpinner";
import { twMerge } from "tailwind-merge";

type Props = {
  children?: React.ReactNode;
  loading?: boolean;
  noStyles?: boolean;
  innerRef?: React.Ref<HTMLDivElement>;
} & React.HTMLAttributes<HTMLDivElement>;

export const BasicContainer: React.FC<Props> = ({
  children,
  className,
  loading,
  noStyles,
  innerRef,
  ...attributes
}) => {
  return (
    <div
    ref={innerRef}
      className={twMerge(
        "relative",
        !noStyles &&
          "flex w-fit flex-col items-center justify-center gap-5 overflow-visible rounded-2xl bg-white p-6",
        className
      )}
      {...attributes}
    >
      <div
        className={twMerge(
          "absolute top-0 bottom-0 left-0 right-0 -z-10 flex items-center justify-center bg-white bg-opacity-0 transition-all",
          loading && "z-50 bg-opacity-60 opacity-100"
        )}
      >
        {loading&&<LoadingSpinner className="w-6 h-6 text-blue-300" />}
      </div>
      {children}
    </div>
  );
};

export default BasicContainer;
